module.exports = __webpack_public_path__ + "static/media/loading_blue.c4ac936d.gif";